<template>
  <div id="dixin">
    <!--指示阶段-->
    <div class="topbox relativeItem">
      <p class="p1">{{ obj.expect_price }}</p>
      <p class="p2">预计奖励</p>
      <!--底薪说明-->
      <img
        class="absoluteItem tipimg"
        src="../../assets/task/task(16).png"
        @click="to_doc"
        v-if="obj.Reaching_standard.length === 0"
      />
      <div class="dixintip absoluteItem" @click="to_doc" v-else>如何提升底薪奖励?</div>

      <!--未开启时-->
      <div class="absoluteItem centerImg nonetip" v-if="obj.Reaching_standard.length === 0">
        <img src="../../assets/task/task(10).png" />
        <p class="absoluteItem centerImg">底薪奖励暂未开启</p>
      </div>

      <!--已开启的阶段-->
      <div class="line relativeItem" v-if="obj.Reaching_standard.length != 0">
        <p>
          <span :style="{width:line_width_span[obj.standardstatus-1]}"></span>
        </p>
        <!--一阶段-->
        <img
          class="box1-close1 absoluteItem centerY"
          src="../../assets/task/task(6).png"
          v-if="obj.Reaching_standard[0].finished == 0 && nav_index != 0"
          @click="change_nav_index(0)"
        />
        <img
          class="box1-close2 absoluteItem centerY"
          src="../../assets/task/task(5).png"
          v-if="obj.Reaching_standard[0].finished == 0 && nav_index === 0"
        />
        <img
          class="box1-open1 absoluteItem centerY"
          src="../../assets/task/task(14).png"
          v-if="obj.Reaching_standard[0].finished == 1 && nav_index != 0"
          @click="change_nav_index(0)"
        />
        <img
          class="box1-open2 absoluteItem centerY"
          src="../../assets/task/task(15).png"
          v-if="obj.Reaching_standard[0].finished == 1 && nav_index === 0"
        />
        <!--二阶段-->
        <img
          class="box2-close1 absoluteItem centerY"
          src="../../assets/task/task(6).png"
          v-if="obj.Reaching_standard[1].finished == 0 && nav_index != 1"
          @click="change_nav_index(1)"
        />
        <img
          class="box2-close2 absoluteItem centerY"
          src="../../assets/task/task(5).png"
          v-if="obj.Reaching_standard[1].finished == 0 && nav_index === 1"
        />
        <img
          class="box2-open1 absoluteItem centerY"
          src="../../assets/task/task(14).png"
          v-if="obj.Reaching_standard[1].finished == 1 && nav_index != 1"
          @click="change_nav_index(1)"
        />
        <img
          class="box2-open2 absoluteItem centerY"
          src="../../assets/task/task(15).png"
          v-if="obj.Reaching_standard[1].finished == 1 && nav_index === 1"
        />
        <!--三阶段-->
        <img
          class="box3-close1 absoluteItem centerY"
          src="../../assets/task/task(6).png"
          v-if="obj.Reaching_standard[2].finished == 0 && nav_index != 2"
          @click="change_nav_index(2)"
        />
        <img
          class="box3-close2 absoluteItem centerY"
          src="../../assets/task/task(5).png"
          v-if="obj.Reaching_standard[2].finished == 0 && nav_index === 2"
        />
        <img
          class="box3-open1 absoluteItem centerY"
          src="../../assets/task/task(14).png"
          v-if="obj.Reaching_standard[2].finished == 1 && nav_index != 2"
          @click="change_nav_index(2)"
        />
        <img
          class="box3-open2 absoluteItem centerY"
          src="../../assets/task/task(15).png"
          v-if="obj.Reaching_standard[2].finished == 1 && nav_index === 2"
        />
        <!--四阶段-->
        <img
          class="box4-close1 absoluteItem centerY"
          src="../../assets/task/task(6).png"
          v-if="obj.Reaching_standard[3].finished == 0 && nav_index != 3"
          @click="change_nav_index(3)"
        />
        <img
          class="box4-close2 absoluteItem centerY"
          src="../../assets/task/task(5).png"
          v-if="obj.Reaching_standard[3].finished == 0 && nav_index === 3"
        />
        <img
          class="box4-open1 absoluteItem centerY"
          src="../../assets/task/task(14).png"
          v-if="obj.Reaching_standard[3].finished == 1 && nav_index != 3"
          @click="change_nav_index(3)"
        />
        <img
          class="box4-open2 absoluteItem centerY"
          src="../../assets/task/task(15).png"
          v-if="obj.Reaching_standard[3].finished == 1 && nav_index === 2"
        />
      </div>
      <ul class="nav flex-box relativeItem dixin_nav" v-if="obj.Reaching_standard.length != 0">
        <li
          v-for="(n, index) in navs"
          :key="index"
          class="relativeItem"
          :class="{ac:nav_index === index}"
          @click="change_nav_index(index)"
        >{{ n }}</li>

        <!--滑块颜色-->
        <div class="absoluteItem centerY huakuai" :style="{left:nav_huakuai_left}">一阶段</div>
      </ul>
    </div>

    <!--开启条件-->
    <div v-if="obj.Reaching_standard.length === 0">
      <p class="title-tip">开启条件</p>
      <div class="condition">
        <div class="con1 relativeItem">
          <p class="p1">{{ obj.Not_up_to_standard.taskArr[0].title }}</p>
          <p class="p2 flex-box">
            <span>{{ obj.Not_up_to_standard.taskArr[0].cont }}</span>
            <span>{{ obj.Not_up_to_standard.taskArr[0].msg }}</span>
          </p>
          <p class="p3">
            <span
              :style="{width:(obj.Not_up_to_standard.taskArr[0].complete_val*1/(obj.Not_up_to_standard.taskArr[0].task_val*1)*100) + '%'}"
            ></span>
          </p>
          <!--按钮-->
          <span class="s-button absoluteItem centerY" @click="take_task(0)">去升级</span>
        </div>
        <div class="con2 relativeItem">
          <p class="p1">{{ obj.Not_up_to_standard.taskArr[1].title }}</p>
          <p class="p2 flex-box">
            <span>{{ obj.Not_up_to_standard.taskArr[1].cont }}</span>
            <span>{{ obj.Not_up_to_standard.taskArr[1].msg }}</span>
          </p>
          <p class="p3">
            <span
              :style="{width:(obj.Not_up_to_standard.taskArr[1].complete_val*1/(obj.Not_up_to_standard.taskArr[1].task_val*1)*100) + '%'}"
            ></span>
          </p>
          <!--按钮-->
          <span class="s-button absoluteItem centerY" @click="take_task(1)">去邀请</span>
        </div>
      </div>
    </div>

    <!--各阶段-->
    <div v-else>
      <swiper :options="swiperOption" ref="dixinSwiper" class="dixin-switer">
        <!--第一阶段-->
        <swiper-slide v-for="(n, index) in obj.Reaching_standard" :key="index">
          <div>
            <p class="title-tip">{{ n.msg }}</p>
            <p class="title-tip-S" v-if="n.minmsg != ''">{{ n.minmsg }}</p>
            <dixinJiangli
              :list="n.displayReward"
              :complete_val="n.complete_val"
              :showtime="n.showtime"
              v-if="n.finished == 1"
            ></dixinJiangli>
            <taskline v-else :list="n.stage" :type="'basepay'"></taskline>
          </div>
        </swiper-slide>
      </swiper>

      <p class="bottom-text flex-box">
        <img src="../../assets/task/task(1).png" />
        当前任务时间段所属{{ time }}
      </p>
    </div>
  </div>
</template>





















<script>
import taskline from "./taskline";
import dixinJiangli from "./dixin_jiangli";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "taskcenter",
  components: { taskline, swiper, swiperSlide, dixinJiangli },
  props: ["obj"],
  data() {
    return {
      navs: ["一阶段", "二阶段", "三阶段", "四阶段"],
      nav_index: 0, //顶部导航指示标
      stage: 2, //目前所处阶段 0未开启
      time: "2020年4月9日",
      line_width_span: ["0%", "35%", "65%", "100%"],
      line_width: "0%", //宝箱进度条
      nav_huakuai_left: "3px",

      swiperOption: {
        speed: 500,
        autoplay: false,
        loop: false,
        self: this,
        centeredSlides: true,
        spaceBetween: 10,
        on: {
          slideChange: () => {
            this.nav_index = this.swiper.activeIndex;
            this.stage = this.nav_index;
            this.reset_bleft(this.nav_index);
          }
        }
      }
    };
  },
  methods: {
    /**通知父组件切换背景颜色 */
    change_nav_index(index) {
      this.nav_index = index;
      this.$emit("change_bk", index);
      this.swiper.slideTo(index);
      this.reset_bleft(index);
    },
    //点击时间切换设置标试点的位置
    reset_bleft(index) {
      let li = document
        .getElementsByClassName("dixin_nav")[0]
        .getElementsByTagName("li")[index];
      this.nav_huakuai_left = li.offsetLeft + "px";
    },

    /**前往底薪说明页面 */
    to_doc() {
      this.$router.push({ path: "/dixin" });
    },

    /**获取当天日期 */
    get_time() {
      let date = new Date();
      this.time =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日";
    },

    /**通知app打开相关页面 */
    take_task(index) {
      let data = {
        ios: this.obj.Not_up_to_standard.taskArr[index].jumpurl.ios,
        android: this.obj.Not_up_to_standard.taskArr[index].jumpurl.ios
      };
      this.$appAc.actionAsPhp(data);
    }
  },
  computed: {
    swiper() {
      return this.$refs.dixinSwiper.swiper;
    }
  },
  mounted: function() {
    this.get_time();
  }
};
</script>



















<style scoped>
/**面板 */
.topbox {
  width: 100%;
  min-height: 172px;
  border-radius: 8px;
  padding: 11px 16px;
  color: white;
  background: rgba(255, 255, 255, 0.16);
  margin-bottom: 8px;
}
.topbox .p1 {
  font-size: 27px;
  font-weight: bold;
  margin-bottom: 2px;
}
.topbox .p2 {
  font-size: 12px;
}
.topbox .tipimg {
  width: 16px;
  height: 16px;
  top: 14px;
  right: 16px;
}
.topbox .dixintip {
  top: 24px;
  right: 16px;
  padding: 5px 16px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.32);
  border-radius: 3rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16);
}
.topbox .nonetip {
  width: 34%;
  font-size: 13px;
}
.topbox .nonetip p {
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}
.topbox .line {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 20px;
}
.topbox .line p {
  width: 100%;
  border-radius: 25px;
  height: 10px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin: 0 auto;
}
.topbox .line span {
  display: block;
  transition: all 0.6s;
  height: 100%;
  border-radius: 25px;
  background: linear-gradient(to right, #ffe544, #ffaa34);
}

/**宝箱定位 */
.box1-close1 {
  width: 25%;
  top: 20%;
  left: -8%;
}
.box1-close2 {
  width: 20%;
  left: -6%;
}
.box1-open1 {
  width: 17%;
  left: -4%;
  top: 11%;
}
.box1-open2 {
  width: 23%;
  left: -7%;
  top: 5%;
}
.box2-close1 {
  width: 25%;
  top: 20%;
  left: 22%;
}
.box2-close2 {
  width: 20%;
  left: 25%;
}
.box2-open1 {
  width: 17%;
  left: 26%;
  top: 11%;
}
.box2-open2 {
  width: 23%;
  left: 23%;
  top: 5%;
}

.box3-close1 {
  width: 25%;
  top: 20%;
  left: 53%;
}
.box3-close2 {
  width: 20%;
  left: 56%;
}
.box3-open1 {
  width: 17%;
  left: 57%;
  top: 11%;
}
.box3-open2 {
  width: 23%;
  left: 54%;
  top: 5%;
}

.box4-close1 {
  width: 25%;
  top: 20%;
  right: -8%;
}
.box4-close2 {
  width: 20%;
  right: -6%;
}
.box4-open1 {
  width: 17%;
  right: -4%;
  top: 11%;
}
.box4-open2 {
  width: 23%;
  right: -7%;
  top: 5%;
}

/**阶段导航 */
.nav {
  overflow: hidden;
  width: 100%;
  height: 30px;
  border-radius: 50px;
  padding: 3px;
  background: rgba(255, 255, 255, 0.16);
  color: white;
  font-size: 12px;
  justify-content: space-between;
  margin-top: 25px;
}
.nav li,
.nav .huakuai {
  width: 25%;
  padding: 4px 10px;
  text-align: center;
  border-radius: 3rem;
  transition: all 0.6s;
}
.nav li {
  position: relative;
  z-index: 1;
}
.nav .huakuai {
  display: block;
  background: #ffd856;
  color: #ffd856;
  z-index: 0;
}
.nav .ac {
  color: #bb3215;
}
.nav span {
  width: 6px;
  height: 6px;
  top: 4px;
  right: 8px;
  border-radius: 50%;
  background: #ff3f34;
}

/**开启条件 */
.title-tip {
  font-size: 12px;
  color: #ffe756;
  text-align: center;
}
.title-tip-S {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  margin-bottom: 8px;
}
.condition {
  margin-top: 9px;
}
.condition > div {
  height: 88px;
  border-radius: 8px;
  overflow: hidden;
  color: white;
  padding: 12px 16px;
}
.condition .p1 {
  font-size: 15px;
  margin-bottom: 13px;
}
.condition .p2,
.condition .p3 {
  width: 75%;
}
.condition .p2 {
  font-size: 12px;
  justify-content: space-between;
  margin-bottom: 6px;
}
.condition .p3 {
  background: rgba(255, 255, 255, 0.16);
  border-radius: 25px;
  height: 4px;
}
.condition .p3 span {
  display: block;
  border-radius: 25px;
  height: 100%;
  transition: all 0.6s;
  background: white;
  max-width: 100%;
}
.condition .s-button {
  right: 16px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 25px;
  padding: 6px 13px;
}
.con1 .s-button {
  color: #ff418c;
}
.con2 .s-button {
  color: #0096b5;
}
.con1 {
  background: url("../../assets/task/task(1).jpg") no-repeat left top;
  background-size: 100% 100%;
  margin-bottom: 8px;
}
.con2 {
  background: url("../../assets/task/task(2).jpg") no-repeat left top;
  background-size: 100% 100%;
}

.bottom-text {
  font-size: 12px;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  align-items: center;
  margin-top: 7px;
}
.bottom-text img {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}
</style>

<style>
.dixin-switer{
  overflow-x: hidden !important;
}
.dixin-switer .swiper-slide {
  padding: 0 !important;
}
</style>
